import Spinner from 'react-bootstrap/Spinner';

function LoadingScreen() {
    return (
        <>
        <Spinner animation="border" />
        </>
    );
    }

export default LoadingScreen;